<div class="checkout-wizard" [class.safari]="isSafari" [ngClass]="screenClasses()">
  <div class="header">
    <div class="author">
      <div class="avatar">
        <on-ui-cover [cover]="avatar"></on-ui-cover>
      </div>
      <div class="info">
        <div class="name">{{ authorData.fullName }}</div>
        <div class="rating">
          <div class="stars" [class.noreting]="authorData.statsRating === 0">
            <app-icon class="rating-icon" icon="rating"></app-icon>
            <span class="rating-count">{{ authorData.statsRating }}</span>
          </div>
          <div class="review-count" *ngIf="authorData.statsMeetCount">
            ({{ authorData.statsMeetCount }} {{ 'library.user-service-card.reviews' | customLocale }})
          </div>
          <div class="school-participants" *ngIf="authorData.participants">
            {{ 'user-profile.teacher-stat.students' | customLocale }}: {{ authorData.participants }}
          </div>
        </div>
      </div>
    </div>

    <div class="steps">
      <app-checkout-steps [steps]="models.steps" [content]="models.content"></app-checkout-steps>
    </div>
    <div class="hr full-width"></div>
  </div>

  <div class="content content-horizontal is-my-content" *ngIf="isMe">
    <div class="is-my-content-text">
      {{
        (typeOfContent === 'collection'
          ? 'user-service-checkout-wizard.is-my-collection-text'
          : 'user-service-checkout-wizard.is-my-lesson-text'
        ) | customLocale
      }}
    </div>
  </div>

  <div class="content content-vertical" *ngIf="!isMe">
    <ng-template [ngIf]="models.isCurrentStep('teacher')">
      <ng-template [ngIf]="models.possibleTeachers.length >= 0">
        <div class="step-title">
          <div class="title">{{ 'meetings.wizard.choose-teacher' | customLocale }}</div>
        </div>
        <div class="user-cards">
          <div
            *ngFor="let teacher of models.possibleTeachers; let i = index; trackBy: trackContentByFn"
            class="user-card-wrap"
            [class.active]="isCurrentTeacherSelected(teacher)">
            <app-user-card-mini [user]="teacher" (click)="onTeacherSelected(teacher)"></app-user-card-mini>
          </div>
        </div>
      </ng-template>
    </ng-template>
    <ng-template [ngIf]="models.isCurrentStep('detail')">
      <loading-line *ngIf="!models.teacher" height="40px" width="100%"></loading-line>
      <app-user-service-detail
        *ngIf="!typeOfContent"
        [teacher]="models.teacher"
        [profile]="teacherProfile"
        [me]="_me"
        (cardFullInModal)="onToggleContentInModal($event)"></app-user-service-detail>
      <app-collection-license-detail
        *ngIf="typeOfContent === 'collection'"
        [content]="contentWithType"
        (selected)="setSelectedLicense($event)"></app-collection-license-detail>
    </ng-template>
    <ng-template [ngIf]="models.isCurrentStep('datetime')">
      <ng-template [ngIf]="!isSchedulableService">
        <app-user-service-datetime
          *ngIf="teacherProfile"
          [teacher]="models.teacher"
          [profile]="teacherProfile"
          (timeSelected)="timeSelected()"
          [me]="_me"></app-user-service-datetime>
      </ng-template>
      <ng-template [ngIf]="isSchedulableService">
        <div class="course-block">
          <p class="step-title">{{ 'meetings.wizard.course.choose-group' | customLocale }}</p>
          <clock-spinner *ngIf="loadingCourses"></clock-spinner>
          <ng-template ngFor let-course [ngForOf]="courses" let-i="index" [ngForTrackBy]="trackByFn">
            <app-course-card [course]="course" (courseSelected)="onCourseSelected($event)"></app-course-card>
          </ng-template>
        </div>
      </ng-template>
    </ng-template>

    <ng-template [ngIf]="!paymentProcessing && models.isCurrentStep('payment')"> </ng-template>

    <!-- Для работы с новым биллингом вызывать такой компонент:
    <ng-template [ngIf]="models.isCurrentStep('payment') && hasCharges">
      <app-payment-widget [charges]="charges"></app-payment-widget>
    </ng-template>
    -->
    <ng-template [ngIf]="models.isCurrentStep('payment')">
      <app-payment-widget
        *ngIf="paymentOptions"
        [options]="paymentOptions"
        (configured)="onPaymentConfigured($event)"
        (succeed)="onPaymentSucceed()"
        (failed)="onPaymentFailed($event)"
        (processing)="onPaymentProcessing($event)"
        (addAccount)="onAddAccount($event)"></app-payment-widget>
    </ng-template>

    <ng-template [ngIf]="!paymentProcessing && models.done">
      <div class="finish-fail" *ngIf="models.fail">
        <div class="title">{{ 'meetings.wizard.pay-fail' | customLocale }}</div>
        <svg class="icon" width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z"
            fill="#E86F79" />
          <rect x="29" y="35" width="8" height="50" rx="4" transform="rotate(-45 29 35)" fill="white" />
          <rect x="35" y="70" width="8" height="50" rx="4" transform="rotate(-135 35 70)" fill="white" />
        </svg>
      </div>
      <div class="finish-success" *ngIf="!models.fail">
        <div class="title">{{ 'meetings.wizard.pay-success' | customLocale }}</div>
        <svg class="icon" width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M49 0C21.9803 0 0 21.9803 0 49C0 76.0197 21.9803 98 49 98C76.0197 98 98 76.0197 98 49C98 21.9803 76.0197 0 49 0Z"
            fill="#87D37C" />
          <path
            d="M74.7524 38.2306L47.0937 65.7585C46.2639 66.5843 45.1747 67 44.0854 67C42.9962 67 41.9069 66.5843 41.0772 65.7585L27.2482 51.9945C25.5839 50.3389 25.5839 47.6619 27.2482 46.0063C28.9116 44.3498 31.6005 44.3498 33.2647 46.0063L44.0854 56.7761L68.7359 32.2423C70.3993 30.5859 73.0882 30.5859 74.7524 32.2423C76.4159 33.898 76.4159 36.5741 74.7524 38.2306Z"
            fill="#FAFAFA" />
        </svg>
      </div>
    </ng-template>
  </div>

  <div class="footer" *ngIf="showFooter">
    <div class="hr full-width"></div>
    <div class="content-info">
      <div class="cover" *ngIf="!contentData.multiCover?.length">
        <on-ui-cover [cover]="contentData.coverUrl"></on-ui-cover>
      </div>
      <div class="cover-block" *ngIf="contentData.multiCover?.length">
        <div
          *ngFor="let cover of contentData.multiCover; let i = index; trackBy: trackByFn"
          class="cover-item"
          [ngClass]="coverCssClasses(contentData.multiCover?.length, i)">
          <on-ui-cover [cover]="coverCollection(cover)"></on-ui-cover>
        </div>
      </div>
      <div class="info">
        <div class="subject">{{ contentData.subjectTitle }}</div>
        <div class="title">{{ contentData.title }}</div>
        <div class="more-info">
          <ul *ngIf="!models.calendar.time.length && !isUserService">
            <li *ngIf="contentData.startDate">{{ dateStringToDate(contentData.startDate) | dfnsFormat: 'EEE' }}</li>
            <li *ngIf="contentData.startDate">
              {{ dateStringToDate(contentData.startDate) | dfnsFormat: 'HH:mm' }} -
              {{ dateStringToDate(contentData.endDate) | dfnsFormat: 'HH:mm' }}
            </li>
            <li *ngIf="contentData.lessons">{{ 'collections.text.items' | customLocale }} {{ contentData.lessons }}</li>
            <li *ngIf="contentData.meetings_limit">
              {{ 'teacher-card.stats.classes' | customLocale }} {{ contentData.meetings_limit }}
            </li>
            <li *ngIf="contentData.level">{{ 'subject-levels.' + contentData.level | customLocale }}</li>
            <li *ngIf="contentData.age_from && contentData.age_to">
              {{ 'user-service-form-3.fields.label9' | customLocale }} {{ contentData.age_from }}-{{
                contentData.age_to
              }}
            </li>
          </ul>

          <ul *ngIf="isUserService">
            <li *ngIf="models.calendar.time">
              Дата:
              <span class="value" *ngIf="models.calendar.time">{{
                calcMeetDate(models.calendar.time) | dfnsFormat: 'dd MMMM yyyy'
              }}</span>
            </li>
            <li *ngIf="models.calendar.time">
              Время: <span class="value" *ngIf="models.calendar.time">{{ calcMeetTime(models.calendar.time) }}</span>
            </li>
            <!--<li>{{ formatCurrencyAmount(servicePrice?.amount, currency_id) }}</li>
            <li class="total text-right">{{ formatCurrencyAmount(servicePrice?.amount, currency_id) }}</li>-->
          </ul>
        </div>
      </div>
      <div class="type">{{ contentData.type | customLocale }}</div>
    </div>

    <div class="actions">
      <ng-template [ngIf]="models.isCurrentStep('teacher') && models.teacher">
        <on-ui-button
          class="secondary"
          [disabled]="isMe"
          label="user-service-checkout-wizard.next"
          (onclick)="selectTeacher()">
        </on-ui-button>
      </ng-template>
      <ng-template [ngIf]="models.isCurrentStep('detail')">
        <on-ui-button class="secondary" label="user-service-checkout-wizard.next" (onclick)="selectContent()">
        </on-ui-button>
      </ng-template>
      <ng-template [ngIf]="models.isCurrentStep('datetime')">
        <on-ui-button class="status" label="Unavailable"></on-ui-button>
        <!--
        <on-ui-button [disabled]="!models.calendar.time.length || signupProcessing"
                      class="secondary"
                      label="user-service-checkout-wizard.next"
                      (click)="signupToService()">
        </on-ui-button>
        -->
      </ng-template>
      <ng-template [ngIf]="models.isCurrentStep('payment')">
        <on-ui-button
          *ngIf="payButtonsState !== 'progress'"
          [state]="payButtonsState"
          [disabled]="!paymentFormValid || !!errorMessage"
          class="secondary"
          [label]="'meetings.wizard.pay' | customLocale"
          (click)="executePayment()">
        </on-ui-button>
      </ng-template>
      <ng-template [ngIf]="models.done && !models.fail">
        <on-ui-button
          class="secondary"
          label="user-service-checkout-wizard.close"
          (onclick)="closed.emit(true); stateChanged.emit(models.step)">
        </on-ui-button>
      </ng-template>
      <ng-template [ngIf]="models.done && models.fail">
        <on-ui-button
          class="primary outline margin-right"
          label="user-service-checkout-wizard.to-complete"
          (onclick)="closed.emit(true)">
        </on-ui-button>
        <on-ui-button class="secondary" label="user-service-checkout-wizard.try-again" (onclick)="resetForm()">
        </on-ui-button>
      </ng-template>
    </div>

    <span *ngIf="errorMessage" class="error">{{ errorMessage }}</span>
  </div>
</div>
